import type { FC } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Container } from './Container';
import { GameContainerProps } from './interfaces';

export const MprcImageMapInput: FC<GameContainerProps> = (props) => {
    return (
        <DndProvider backend={HTML5Backend} >
            <div>
                <Container
                    {...props}
                />
            </div>
        </DndProvider>
    );
};
